(function () {
  function formatWeight(weightG) {
    if (weightG == null) return '';
    weightG = parseInt(weightG, 10);
    if (weightG < 1000) return `Weight per piece: ${weightG} g`;
    const kg = weightG / 1000;
    const txt = kg.toFixed(2).replace(/\.00$/, '').replace(/(\.\d)0$/, '$1');
    return `Weight per piece: ${txt} kg`;
  }

  function getVariantsArray() {
    const jsonEl = document.getElementById('ips-product-variants-json');
    if (jsonEl) {
      try { return JSON.parse(jsonEl.textContent); } catch (e) {}
    }
    return null;
  }

  function findCurrentVariantId() {
    const idInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (idInput && idInput.value) return idInput.value;
    return null;
  }

  function renderWeight() {
    const out = document.getElementById('variant-weight-text');
    const variants = getVariantsArray();
    const id = findCurrentVariantId();
    if (!out || !variants || !id) return;

    const v = variants.find(x => String(x.id) === String(id));
    if (!v) return;

    out.textContent = formatWeight(v.weight);
  }

  document.addEventListener('DOMContentLoaded', renderWeight);

  // Wokiee swatches/dropdowns usually trigger change/click inside the ATC form
  document.addEventListener('change', (e) => {
    if (!e.target.closest('form[action*="/cart/add"]')) return;
    setTimeout(renderWeight, 0);
  });

  document.addEventListener('click', (e) => {
    if (!e.target.closest('form[action*="/cart/add"]')) return;
    setTimeout(renderWeight, 0);
  });
})();
